import {
  SET_SELECTED_CATEGORY,
  SET_SELECTED_CATEGORIES,
  SET_CATEGORIES,
  SET_CATEGORIES_LOADING,
  SET_AVAILABLE_CATEGORIES,
  GET_CATEGORIES,
  GET_AVAILABLE_CATEGORIES,
  GET_PRODUCT_IDS,
  SET_PRODUCT_IDS_LOADING,
  SET_PRODUCT_IDS
} from '../actions/archive'

const state = {
  categories: {},
  isCategoriesLoading: false,
  isProductIdsLoading: false,
  selected: {},
  available: {},
  productIds: []
}

const getters = {
  getCategories: state => state.categories,
  isCategoriesLoading: state => state.isCategoriesLoading,
  isProductIdsLoading: state => state.isProductIdsLoading,
  getSelectedCategories: state => state.selected,
  getAvailableCategories: state => state.available
}

const actions = {
  [SET_SELECTED_CATEGORIES] ({ commit, getters }, { checked, group }) {
    const selected = { ...getters.getSelectedCategories }
    const categories = getters.getCategories
    const available = getters.getAvailableCategories
    Object.keys(categories[group].subcategories).forEach(category => {
      selected[category] = available[category] && checked
    })
    commit(SET_SELECTED_CATEGORIES, selected)
  },
  [SET_SELECTED_CATEGORY] ({ commit, getters }, { checked, category }) {
    const selected = { ...getters.getSelectedCategories }
    selected[category] = checked
    commit(SET_SELECTED_CATEGORIES, selected)
  },
  [GET_PRODUCT_IDS] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit(SET_PRODUCT_IDS_LOADING, true)
      this._vm.$api.archive.productIds(params).then(response => {
        commit(SET_PRODUCT_IDS, response.data)
        commit(SET_PRODUCT_IDS_LOADING, false)
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [GET_AVAILABLE_CATEGORIES] ({ commit }, productIds) {
    return new Promise((resolve, reject) => {
      commit(SET_CATEGORIES_LOADING, true)
      this._vm.$api.archive.availableCategories({ productIds }).then(response => {
        commit(SET_AVAILABLE_CATEGORIES, response.data)
        commit(SET_CATEGORIES_LOADING, false)
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [GET_CATEGORIES] ({ commit }) {
    return new Promise((resolve, reject) => {
      commit(SET_CATEGORIES_LOADING, true)
      this._vm.$api.archive.categoryList().then(response => {
        commit(SET_CATEGORIES, response.data)
        commit(SET_CATEGORIES_LOADING, false)
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  [SET_SELECTED_CATEGORIES]: (state, selected) => {
    state.selected = selected
  },
  [SET_AVAILABLE_CATEGORIES]: (state, available) => {
    state.available = available
  },
  [SET_CATEGORIES]: (state, categories) => {
    state.categories = categories
  },
  [SET_PRODUCT_IDS]: (state, productIds) => {
    state.productIds = productIds
  },
  [SET_CATEGORIES_LOADING]: (state, value) => {
    state.isCategoriesLoading = value
  },
  [SET_PRODUCT_IDS_LOADING]: (state, value) => {
    state.isProductIdsLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
